// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.waiting-room-panel {
  position: fixed;
  top: 80px;
  right: 20px;
  width: 320px;
  max-height: 400px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  overflow: hidden;
}

.waiting-room-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.waiting-room-panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background 0.2s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.waiting-room-panel-content {
  max-height: 320px;
  overflow-y: auto;
}

.empty-waiting-room {
  padding: 40px 20px;
  text-align: center;
  color: #666;
}

.empty-waiting-room p {
  margin: 0;
  font-size: 14px;
}

.waiting-room-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.waiting-room-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
  transition: background 0.2s;
}

.waiting-room-item:hover {
  background: #f8f9fa;
}

.waiting-room-item:last-child {
  border-bottom: none;
}

.waiting-room-item .user-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.waiting-room-item .user-name {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.waiting-room-item .waiting-time {
  font-size: 12px;
  color: #999;
}

.waiting-room-actions {
  display: flex;
  gap: 8px;
}

.approve-btn,
.deny-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.approve-btn {
  background: #28a745;
  color: white;
}

.approve-btn:hover {
  background: #218838;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.4);
}

.deny-btn {
  background: #dc3545;
  color: white;
}

.deny-btn:hover {
  background: #c82333;
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.4);
}

@media (max-width: 768px) {
  .waiting-room-panel {
    width: 100%;
    max-width: none;
    top: 60px;
    right: 0;
    height: calc(100vh - 60px);
    max-height: none;
    border-radius: 0;
  }

  .waiting-room-panel-header {
    padding: 14px;
  }

  .waiting-room-panel-header h3 {
    font-size: 15px;
  }

  .close-btn {
    width: 24px;
    height: 24px;
    font-size: 18px;
  }

  .waiting-room-item {
    padding: 10px 12px;
  }

  .waiting-room-item .user-name {
    font-size: 13px;
  }

  .approve-btn,
  .deny-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WaitingRoomPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE;IACE,WAAW;IACX,eAAe;IACf,SAAS;IACT,QAAQ;IACR,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF","sourcesContent":[".waiting-room-panel {\r\n  position: fixed;\r\n  top: 80px;\r\n  right: 20px;\r\n  width: 320px;\r\n  max-height: 400px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  overflow: hidden;\r\n}\r\n\r\n.waiting-room-panel-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n}\r\n\r\n.waiting-room-panel-header h3 {\r\n  margin: 0;\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n}\r\n\r\n.close-btn {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  width: 28px;\r\n  height: 28px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 4px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.waiting-room-panel-content {\r\n  max-height: 320px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.empty-waiting-room {\r\n  padding: 40px 20px;\r\n  text-align: center;\r\n  color: #666;\r\n}\r\n\r\n.empty-waiting-room p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n.waiting-room-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.waiting-room-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid #eee;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.waiting-room-item:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.waiting-room-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.waiting-room-item .user-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n.waiting-room-item .user-name {\r\n  font-weight: 600;\r\n  color: #333;\r\n  font-size: 14px;\r\n}\r\n\r\n.waiting-room-item .waiting-time {\r\n  font-size: 12px;\r\n  color: #999;\r\n}\r\n\r\n.waiting-room-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.approve-btn,\r\n.deny-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  transition: transform 0.2s, box-shadow 0.2s;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.approve-btn {\r\n  background: #28a745;\r\n  color: white;\r\n}\r\n\r\n.approve-btn:hover {\r\n  background: #218838;\r\n  transform: scale(1.1);\r\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.4);\r\n}\r\n\r\n.deny-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n}\r\n\r\n.deny-btn:hover {\r\n  background: #c82333;\r\n  transform: scale(1.1);\r\n  box-shadow: 0 2px 8px rgba(220, 53, 69, 0.4);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .waiting-room-panel {\r\n    width: 100%;\r\n    max-width: none;\r\n    top: 60px;\r\n    right: 0;\r\n    height: calc(100vh - 60px);\r\n    max-height: none;\r\n    border-radius: 0;\r\n  }\r\n\r\n  .waiting-room-panel-header {\r\n    padding: 14px;\r\n  }\r\n\r\n  .waiting-room-panel-header h3 {\r\n    font-size: 15px;\r\n  }\r\n\r\n  .close-btn {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .waiting-room-item {\r\n    padding: 10px 12px;\r\n  }\r\n\r\n  .waiting-room-item .user-name {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .approve-btn,\r\n  .deny-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
